import { render, staticRenderFns } from "./NewLabelCategorySettingsDropdown.vue?vue&type=template&id=16eebad6&scoped=true&"
import script from "./NewLabelCategorySettingsDropdown.vue?vue&type=script&lang=js&"
export * from "./NewLabelCategorySettingsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16eebad6",
  null
  
)

export default component.exports